import { useEffect, useState } from 'react'
import { handleSetSentiment, saveDataToTextField } from '../tooltip-select.helper'
import { Sentiment, TooltipSelectOption } from '../tooltip-select.model'

const useReactTooltipSelect = (getDataHandler: string) => {
	const [options, setOptions] = useState<TooltipSelectOption[] | null>(null)
	const [menuIsOpen, setMenuIsOpen] = useState<boolean>(false)
	const [isLoading, setLoading] = useState<boolean>(true)

	const fetchData = async () => {
		window.Loader.showMain()
		const response = await fetch(getDataHandler)
		const dataResponse = await response.json()
		saveDataToTextField(dataResponse)
		setOptions(dataResponse)
		window.Loader.hideMain()
	}

	useEffect(() => {
		setLoading(true)
		fetchData()
		setLoading(false)
	}, [])

	return {
		options,
		isLoading,
		menuIsOpen,
		setOptions,
		setMenuIsOpen,
		handleSetSentiment: (newSentiment: Sentiment, value: string) =>
			handleSetSentiment(options, newSentiment, value, setOptions, setMenuIsOpen),
	}
}

export default useReactTooltipSelect
